/*!
  Pioneer WFRIA ItemsPerPage v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["ItemsPerPage"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("ItemsPerPage") < 0) {
    window.__PIONEER_GLOBAL__.components.push("ItemsPerPage");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import Button from "../Button/Button";
import { useUniqueId } from "../common/hooks";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export default function ItemsPerPage(props) {
  const {
    id,
    className,
    options,
    selectedItemIndex,
    componentStrings: {
      itemsPerPage,
      itemsPerPageListAriaLabel
    },
    onItemClick,
    onKeyDown,
    expanded
  } = props;
  const uniqueId = useUniqueId();
  const itemsPerPageSection = clsx(className, "pnr-paginator__accordion-items-per-page-section");
  return _jsx("div", {
    "aria-hidden": !expanded,
    "aria-label": itemsPerPageListAriaLabel,
    "aria-live": "polite",
    id: id,
    className: itemsPerPageSection,
    role: "group",
    children: _jsx("ul", {
      className: "pnr-paginator__items-list",
      children: options.map((item, index) => {
        const itemIsSelected = selectedItemIndex === index;
        const itemsPerPageListItemClassNames = clsx("pnr-paginator__list-item", {
          "pnr-paginator__list-item--selected": itemIsSelected
        });
        const pageRangeBtnClassNames = clsx("pnr-paginator__list-item-button", {
          "pnr-paginator__list-item-button--selected": itemIsSelected
        });
        const btnLabel = `${item} ${itemsPerPage}`;
        const uniqueKey = `${index}-${uniqueId}`;
        return _jsx("li", {
          className: itemsPerPageListItemClassNames,
          children: _jsx(Button, {
            "aria-label": btnLabel,
            className: pageRangeBtnClassNames,
            id: `pnr-paginator-items-per-page-${index}`,
            kind: "simple",
            onClick: onItemClick,
            active: itemIsSelected,
            onKeyDown: onKeyDown,
            children: btnLabel
          })
        }, `pnr-paginator-items-per-page-${uniqueKey}`);
      })
    })
  });
}
ItemsPerPage.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Classes which are applied to the "Items per page" container. */
  className: PropTypes.string,

  /** Strings which are required for the "Items per page" menu. */
  componentStrings: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** Expand state of the Menu. It will be used for applying aria attributes. */
  expanded: PropTypes.bool,

  /** ID which is applied to the "Items per page" container. */
  id: PropTypes.string,

  /** Handler executed on click of an item. */
  onItemClick: PropTypes.func,

  /** Handler executed on keydown of an item. */
  onKeyDown: PropTypes.func,

  /** Options to be listed in the "Items per page" menu. */
  options: PropTypes.arrayOf(PropTypes.number),

  /** Item selected in the "Items per page" menu. */
  selectedItemIndex: PropTypes.number
} : {};
ItemsPerPage.defaultProps = {
  className: "",
  componentStrings: null,
  expanded: false,
  id: "",
  onItemClick: null,
  onKeyDown: null,
  options: null,
  selectedItemIndex: ""
};